// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"8a94e876","123":"05ae353b","345":"f5b34946","410":"70be2c13","422":"d82c02af","481":"a881fdb6","504":"612a3a2a","598":"5a07adb1","682":"a81fc070","708":"6fcc90b4","959":"d74f2572"}[chunkId] + ".chunk.js";
};